import motor from '../../../../resource/image/motorPlaceholder.jpg';
import orignalOil from '../../../../resource/image/original-oil.jpg';
import locations from '../../../../resource/image/locations.png';
import parts from '../../../../resource/image/parts.png';
import './MBBeVoContent.css';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {WbIcon} from '@workbench/react';
import {Icon} from '@workbench/core';

const MBBeVoContent = () => {
    const {t, i18n} = useTranslation();
    const languagePrefixMap = {
        de: 'de/de',
        en: 'gb/en',
        pt: 'pt/pt',
    };
    const langPrefix = languagePrefixMap[i18n.language as keyof typeof languagePrefixMap] || 'de/de';

    return (
        <>
            <div className='wb-grid-row'>
                <div
                    className='wb-grid-col-mq1-12 wb-grid-col-mq2-12 wb-grid-col-mq3-6 wb-grid-col-mq4-6 wb-grid-col-mq5-6 wb-grid-col-mq6-6'>
                    <p className='wb-type-heading-m MBBeVoContent__text MBBeVoContent__spaceBottom MBBeVoContent__title-top'>
                        Mercedes-Benz Trucks Operating Fluids
                    </p>
                    <img src={motor} className='MBBeVoContent__image' alt="motor"></img>
                </div>

                <div
                    className='wb-grid-col-mq1-12 wb-grid-col-mq2-12 wb-grid-col-mq3-6 wb-grid-col-mq4-6 wb-grid-col-mq5-6 wb-grid-col-mq6-6'>
                    <p className='wb-type-heading-m MBBeVoContent__text  MBBeVoContent__title-bottom'>
                        Mercedes-Benz Trucks Operating Fluids
                    </p>
                    <p className='contentText wb-type-copy-tertiary MBBeVoContent__text MBBeVoContent__text-bottom custom-mt-50'>
                        {t('IntroductionContent')}
                    </p>
                </div>
            </div>
            <div className='spacer-mainpage-content'></div>
            <div className='wb-grid-row'>
                <div
                    className='wb-grid-col-mq1-12 wb-grid-col-mq2-12 wb-grid-col-mq3-6 wb-grid-col-mq4-6 wb-grid-col-mq5-6 wb-grid-col-mq6-6 order-2'>
                    <p className='wb-type-heading-m MBBeVoContent__text  MBBeVoContent__title-bottom'>
                        {t('OrignalOilTitle')}
                    </p>
                    <p className='contentText wb-type-copy-tertiary MBBeVoContent__text MBBeVoContent__text-bottom'>
                        {t('OrignalOilContent')}
                    </p>
                    <Link
                        className='wb-button--primary MBBeVoIconCard__button-anchor custom-mbbevo-button'
                        to={`https://www.mercedes-benz-trucks.com/${langPrefix}/parts/replacement-parts/engine-oil-and-chemical-products.html`}
                        target='_blank'
                    >
                        <div className='custom-mbbevo-button__icon-wrapper'>
                            <WbIcon
                                className='MBBeVoIconCard__button-icon'
                                name={Icon.ChevronRight}
                            />
                            <p className='wb-type-button'>{t('LearnMore')}</p>
                        </div>
                    </Link>
                </div>
                <div
                    className='wb-grid-col-mq1-12 wb-grid-col-mq2-12 wb-grid-col-mq3-6 wb-grid-col-mq4-6 wb-grid-col-mq5-6 wb-grid-col-mq6-6 order-1'>
                    <p className='wb-type-heading-m MBBeVoContent__text MBBeVoContent__spaceBottom MBBeVoContent__title-top'>
                        Mercedes-Benz Trucks Operating Fluids
                    </p>
                    <img src={orignalOil} className='MBBeVoContent__image' alt="Oil"></img>
                </div>
            </div>
            <div className='spacer-mainpage-content'></div>
            <div className='wb-grid-row'>
                <div
                    className='wb-grid-col-mq1-12 wb-grid-col-mq2-12 wb-grid-col-mq3-6 wb-grid-col-mq4-6 wb-grid-col-mq5-6 wb-grid-col-mq6-6'>
                    <p className='wb-type-heading-m MBBeVoContent__text MBBeVoContent__spaceBottom MBBeVoContent__title-top'>
                        Mercedes-Benz Trucks Operating Fluids
                    </p>
                    <img src={parts} className='MBBeVoContent__image' alt="parts"></img>
                </div>

                <div
                    className='wb-grid-col-mq1-12 wb-grid-col-mq2-12 wb-grid-col-mq3-6 wb-grid-col-mq4-6 wb-grid-col-mq5-6 wb-grid-col-mq6-6'>
                    <p className='wb-type-heading-m MBBeVoContent__text  MBBeVoContent__title-bottom'>
                        {t('TruckParts')}
                    </p>
                    <p className='contentText wb-type-copy-tertiary MBBeVoContent__text MBBeVoContent__text-bottom'>
                        {t('PartsContent')}
                    </p>
                    <Link
                        className='wb-button--primary MBBeVoIconCard__button-anchor custom-mbbevo-button'
                        to={`https://www.mercedes-benz-trucks.com/${langPrefix}/parts/replacement-parts/truckparts.html`}
                        target='_blank'
                    >
                        <div className='custom-mbbevo-button__icon-wrapper'>
                            <WbIcon
                                className='MBBeVoIconCard__button-icon'
                                name={Icon.ChevronRight}
                            />
                            <p className='wb-type-button'>{t('LearnMore')}</p>
                        </div>
                    </Link>
                </div>
            </div>
            <div className='spacer-mainpage-content'></div>
            <div className='wb-grid-row'>
                <div
                    className='wb-grid-col-mq1-12 wb-grid-col-mq2-12 wb-grid-col-mq3-6 wb-grid-col-mq4-6 wb-grid-col-mq5-6 wb-grid-col-mq6-6 order-2'>
                    <p className='wb-type-heading-m MBBeVoContent__text  MBBeVoContent__title-bottom'>
                        {t('LocationsTitle')}
                    </p>
                    <p className='contentText wb-type-copy-tertiary MBBeVoContent__text MBBeVoContent__text-bottom'>
                        {t('LocationsContent')}
                    </p>
                    <Link
                        className='wb-button--primary custom-mbbevo-button custom-mbbevo-button--wide'
                        to={`https://www.mercedes-benz-trucks.com/${langPrefix}/dealer-locator.html`}
                        target='_blank'
                    >
                        <div className='custom-mbbevo-button__icon-wrapper'>
                            <p className='wb-type-button'>{t('FindDealer')}</p>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                                className='custom-mbbevo-button__svg-icon'
                            >
                                <path
                                    d="M11.94 2a6.573 6.573 0 0 0-6.4 5.757 6.314 6.314 0 0 0 .041 1.779 5.9 5.9 0 0 0 .653 1.826L12 22l5.761-10.63a5.96 5.96 0 0 0 .668-1.9 6.272 6.272 0 0 0 .071-.97A6.5 6.5 0 0 0 11.94 2zm.06 9.578A3.077 3.077 0 1 1 15.077 8.5 3.077 3.077 0 0 1 12 11.578z"/>
                            </svg>
                        </div>
                    </Link>
                </div>
                <div
                    className='wb-grid-col-mq1-12 wb-grid-col-mq2-12 wb-grid-col-mq3-6 wb-grid-col-mq4-6 wb-grid-col-mq5-6 wb-grid-col-mq6-6 order-1'>
                    <p className='wb-type-heading-m MBBeVoContent__text MBBeVoContent__spaceBottom MBBeVoContent__title-top'>
                        Mercedes-Benz Trucks Operating Fluids
                    </p>
                    <img src={locations} className='MBBeVoContent__image' alt="locations"></img>
                </div>
            </div>
        </>
    );
};

export default MBBeVoContent;
